<template>

  <svg :style="{height: height + 'px'}" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.75 10.25C14.75 10.6478 14.592 11.0294 14.3107 11.3107C14.0294 11.592 13.6478 11.75 13.25 11.75H4.25L1.25 14.75V2.75C1.25 2.35218 1.40804 1.97064 1.68934 1.68934C1.97064 1.40804 2.35218 1.25 2.75 1.25H13.25C13.6478 1.25 14.0294 1.40804 14.3107 1.68934C14.592 1.97064 14.75 2.35218 14.75 2.75V10.25Z" stroke="#E83B2C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

</template>

<script>
export default {
  name: "DownloadIcon",
  props: {
    height: {
      type: Number,
      default: 16
    }
  }
}
</script>

<style scoped>

</style>